import React, { useEffect } from 'react'
import '../styles/Start.css'
import AOS from 'aos';
import 'aos/dist/aos.css';

const Start = ({ setStart }) => {

  useEffect(() => {
    AOS.init({
      duration: 1000, 
      easing: 'ease-in-out', 
      once: false,
    });
  }, []);

  return (
    <div className="h-screen flex justify-center items-center" data-aos="zoom-out-down">
      <button className="btn-start" onClick={() => setStart(true)}>START</button>
    </div>
  );
};

export default Start;
